let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bSW0m")).then(() => parcelRequire('lRjGz'));